import { useEffect, useState } from 'react';
import { object } from 'prop-types';
import { useLocation } from 'react-router-dom';
import { SubAgentHeader } from 'src/components/layout/SubAgentHeader';
import { getHeaderActions } from 'src/utils/headerActionsHelper';
import { isAgencyApproved } from 'src/utils/agencyStatusHelper';

export const ACCOUNT_NAME_PLACEHOLDER = 'Account';

const Header = ({ config, currentAgent, originalAgent }) => {
  const location = useLocation();
  const [headerActionsState, setHeaderActionsState] = useState({
    mainActions: [],
    secondaryActions: [],
  });
  const [isAgencyStatusApprovedState, setAgencyStatusApproved] =
    useState(false);
  const isOnboarding = location.pathname.includes('/onboarding');
  const isAgentImpersonated = originalAgent.email !== currentAgent.email;
  const fullName = currentAgent?.full_name?.trim() || ACCOUNT_NAME_PLACEHOLDER;
  const originalUser = isAgentImpersonated
    ? {
        name:
          (
            originalAgent?.full_name ||
            [originalAgent.first_name, originalAgent.last_name].join(' ')
          ).trim() || ACCOUNT_NAME_PLACEHOLDER,
        businessName: originalAgent.agency.name,
      }
    : {
        name: fullName,
        businessName: !isOnboarding && currentAgent.agency.name,
      };

  const impersonatedUser = isAgentImpersonated
    ? {
        name: fullName,
        businessName: currentAgent.agency.name,
      }
    : null;

  useEffect(() => {
    const headerActions = getHeaderActions(
      config,
      currentAgent.roles,
      currentAgent.agency.name,
      currentAgent.agency.status,
    );
    setHeaderActionsState({
      ...headerActionsState,
      ...headerActions,
    });

    setAgencyStatusApproved(isAgencyApproved(currentAgent.agency.status));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAgent.agency?.status, originalAgent.agency?.status]);

  const { applicationMode, logoutUrl } = config;

  return (
    <div className="navbar">
      <SubAgentHeader
        originalUser={originalUser}
        impersonatedUser={impersonatedUser}
        mainActions={headerActionsState.mainActions}
        secondaryActions={headerActionsState.secondaryActions}
        applicationMode={applicationMode}
        logoutUrl={logoutUrl}
        isAgencyStatusApproved={isAgencyStatusApprovedState}
      />
    </div>
  );
};

Header.propTypes = {
  config: object.isRequired,
  currentAgent: object.isRequired,
  originalAgent: object.isRequired,
};

export { Header };
